import React, { useEffect } from 'react';
import connect from 'Shared/connect';
import classnames from 'classnames';
import { updateSelectedCompletion, updateQuickSearchCart } from '../../../../../Search/action-creators';
import { addToCart } from '../../../../../Cart/action-creators';
import * as styles from './autocomplete.scss';
import PopularSearches from './PopularSearches';
import SearchSuggestions from './SearchSuggestions';
import ProductSearchList from './ProductSearchList';
import NewsBanner from './NewsBanner';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import MarketingAd from './MarketingAd';
import { scrollPosition } from 'SiteLayout/Root';
import { MEDIUM } from 'Shared/breakpoints';
import SearchCategories from './SearchCategories';
import { getGa4ItemListReferrel, setGa4ItemListReferrel } from '../../../../../TrackingInformation';
const Autocompletions = (props) => {
    const newsBannerBlocks = epiPropertyValue(props.newsBlocks);
    const newsBannerContent = !!newsBannerBlocks && !!newsBannerBlocks.items && !!newsBannerBlocks.items[0] && newsBannerBlocks.items[0];
    const marketingAdBlocks = epiPropertyValue(props.marketingBlocks);
    const marketingAdContent = !!marketingAdBlocks && !!marketingAdBlocks.items && !!marketingAdBlocks.items[0] && marketingAdBlocks.items[0];
    const listenScrollEvent = () => {
        if (props.currentBreakpoint > MEDIUM && scrollPosition() <= 100)
            window.scrollBy(0, 100);
    };
    const showResult = (props.currentBreakpoint > MEDIUM) ? (!!props.open && !!props.visible) : (!!props.open || !!props.visible);
    const searchCategories = !!props.quickSearch.completionsLists.filter(x => x.id === 'suggestions')[0] &&
        !!props.quickSearch.completionsLists.filter(x => x.id === 'suggestions')[0].categorySearchHits
        && props.quickSearch.completionsLists.filter(x => x.id === 'suggestions')[0].categorySearchHits;
    useEffect(() => {
        const itemListReferrel = getGa4ItemListReferrel();
        if (props.open) {
            setGa4ItemListReferrel("Quicksearch");
        }
        else {
            setGa4ItemListReferrel(itemListReferrel);
        }
    }, [props.open]);
    return (!!showResult) && (React.createElement("div", { onScroll: listenScrollEvent, className: classnames(styles.base, props.className, 'ui-test-autocomplete') },
        React.createElement(SearchSuggestions, { thinSelection: props.thinSelection, lists: props.lists, onItemClick: props.onItemClick }),
        React.createElement("div", { className: classnames(styles.twoColumnWrapper, { [styles.border]: !props.thinSelection }) },
            !props.thinSelection && React.createElement("div", { className: styles.leftColumn },
                React.createElement(SearchCategories, { categorySearchHits: searchCategories, onItemClick: props.onItemClick })),
            React.createElement("div", { className: styles.rightColumn },
                React.createElement(ProductSearchList, { lists: props.lists, onItemClick: props.onItemClick, currentBreakpoint: props.currentBreakpoint, searchTerm: props.searchText, totalItems: props.quickSearch.totalItems, helpText: props.helpText, helpTextChat: props.helpTextChat }))),
        React.createElement("div", { className: styles.sectionLists },
            React.createElement("div", { className: styles.section, key: "Popular" },
                !(props.thinSelection && props.searchText.length > 1) && (React.createElement("div", { className: styles.searchSuggestionBackgroundBox },
                    React.createElement(PopularSearches, { onItemClick: props.onItemClick }),
                    !!newsBannerContent && (React.createElement(NewsBanner, Object.assign({}, newsBannerContent))))),
                !!marketingAdContent && (React.createElement(MarketingAd, { currentBreakpoint: props.currentBreakpoint, item: marketingAdContent }))))));
};
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
    newsBlocks: state.quickSearch.searchPage.quickSearchNewsBannerArea,
    marketingBlocks: state.quickSearch.searchPage.quickSearchMarketingAdArea,
    open: state.quickSearch.isOpen,
    helpText: state.quickSearch.searchPage.helpText,
    helpTextChat: state.quickSearch.searchPage.helpTextChat,
    quickSearch: state.quickSearch
}), (dispatch) => ({
    onFocusQuantity(index) {
        dispatch(updateSelectedCompletion(index, 'product'));
    },
    updateCartItemQuantity: (code, quantity, date, unitShortName, ticket) => dispatch(addToCart(code, quantity, unitShortName, ticket, 'QuickSearch')),
    updateUnit: (items, ticket) => {
        const code = items && Object.keys(items)[0];
        return dispatch(updateQuickSearchCart(code, items[code].newQuantity, items[code].newUnitShortName, ticket));
    },
}))(Autocompletions);
